import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const code42 = defineConnector({
  identifier: "code42",
  name: "Code42",
  tagLine: "Insider risk management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.code42\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your [Code42](https://www.code42.com/) console. Navigate to **Administration** > **Users** and create an API client or generate API credentials for your user account.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "hostname",
          label: "Instance URL",
          placeholder: "your-instance.code42.com",
          required: true,
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "Your Code42 instance URL.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "API client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ instanceUrl }) => `https://${instanceUrl}/v1/oauth`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `https://${instanceUrl}/v1/users/current`,
  },
  publicEnvVars: ({ instanceUrl }) => ({
    CODE42_URL: instanceUrl ? `https://${instanceUrl}` : "",
  }),
});
